export const config = {
    "build_timestamp": "2025-06-18T13:35:59.365Z",
    "geoKey": "AIzaSyBeeIWUhRhc2ZW9oKxUugzu8y9JQgFVcvA",
    "zoomSdkKey": "Egz3OjF7ITKvLvhHxRhxLNa5us9uJQ24oJX7",
    "mockServices": false,
    "env": "dh",
    "serverUrl": "https://devdh.eonlineworkshop.com/dhWebsite",
    "imgUrl": "https://devdh.eonlineworkshop.com/",
    "razorAppKey": "rzp_live_yxYVhNWAkRzybF"
};
